import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface ShareBarProps {
  articleId: string;
  title: string;
}

export default function ShareBar({ articleId, title }: ShareBarProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");

  const favorited = isFavorite(articleId);

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2200);
  };

  const getUrl = () => (typeof window !== "undefined" ? window.location.href : "");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(getUrl());
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const handleWechat = async () => {
    try {
      await navigator.clipboard.writeText(getUrl());
    } catch {
      /* ignore */
    }
    showToast("链接已复制，请打开微信粘贴分享");
  };

  const handleWeibo = () => {
    const url = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(getUrl())}&title=${encodeURIComponent(title)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleQQ = () => {
    const url = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(getUrl())}&title=${encodeURIComponent(title)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-xl border border-background-200 bg-background-100 px-4 py-4 md:px-5">
      <div className="flex flex-wrap items-center gap-2">
        <span className="mr-1 text-sm font-medium text-foreground-600">分享到</span>
        <button
          type="button"
          onClick={handleWechat}
          className="flex h-9 items-center gap-1.5 rounded-full bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
        >
          <i className="ri-wechat-line" />
          微信
        </button>
        <button
          type="button"
          onClick={handleWeibo}
          className="flex h-9 items-center gap-1.5 rounded-full bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-800"
        >
          <i className="ri-weibo-line" />
          微博
        </button>
        <button
          type="button"
          onClick={handleQQ}
          className="flex h-9 items-center gap-1.5 rounded-full bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
        >
          <i className="ri-qq-line" />
          QQ空间
        </button>
        <button
          type="button"
          onClick={handleCopy}
          className="flex h-9 items-center gap-1.5 rounded-full bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:bg-background-200"
        >
          <i className="ri-link" />
          复制链接
        </button>
      </div>

      <button
        type="button"
        onClick={() => {
          const now = toggleFavorite(articleId);
          showToast(now ? "已加入收藏" : "已取消收藏");
        }}
        className={`flex h-9 items-center gap-1.5 rounded-full px-4 text-sm font-medium transition-colors ${
          favorited
            ? "bg-accent-500 text-background-50 hover:bg-accent-600"
            : "bg-background-50 text-foreground-700 hover:bg-background-200"
        }`}
      >
        <i className={favorited ? "ri-bookmark-fill" : "ri-bookmark-line"} />
        {favorited ? "已收藏" : "收藏文章"}
      </button>

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-[70] -translate-x-1/2 rounded-full bg-foreground-950 px-5 py-2.5 text-sm text-background-50 shadow-lg animate-fade-up">
          {toast}
        </div>
      )}
    </div>
  );
}